/*
 * Author: Dw
 * File Created: Tuesday, 25-01-14 03:07 pm
 * Last Modified: Tuesday, 25-04-08 07:21 pm, by Dw
 */

import getEnv from './env';

export const DEFAULT_OPEN_API_ERROR_PATHNAME = '/open-api-error';
const DEFAULT_OPEN_API_ERROR_HOST =
  getEnv() === 'local'
    ? 'http://localhost:3000'
    : process.env.NEXT_PUBLIC_SITE_HOST;
export const DEFAULT_ERROR_URL = `${DEFAULT_OPEN_API_ERROR_HOST}${process.env.NEXT_PUBLIC_PREFIX_PATH}${DEFAULT_OPEN_API_ERROR_PATHNAME}`;

export const USE_CUSTOM_ERROR_PAGE: string[] = [];

const checkOpenAPI = () => {
  return process.env.NEXT_PUBLIC_APP_NAME === 'openapi';
};

export const isOpenApi = checkOpenAPI();

// 是否是 decard app
export const isNativeApp = () => {
  if (typeof window === 'undefined') return false;

  return !!(
    /DeCard/i.test(window.navigator.userAgent) ||
    // @ts-ignore
    window.decardAndroid ||
    // @ts-ignore
    window.webkit?.messageHandlers?.decardIOS
  );
};
